module.exports = __webpack_public_path__ + "img/time-covered.9258f84f.svg";